export default __webpack_public_path__ + "static/media/a3.2b4e6a01.jpg";